module.exports = __webpack_public_path__ + "static/headshot2.0a069cea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/headshot2.jpg
// module id = 52
// module chunks = 35783957827783 213720915766396 263791100135453